<template>
  <div class="mx-5">
    <v-snackbar
      v-model="show"
      color="#0C3341"
      :timeout="timeout"
      :class="colorClass"
      :top="true"
    >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="yellow" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";

const defaultErrorMessage = "Something went wrong.";

@Component
export default class AppSnackbar extends Vue {
  show = false;
  color = "";
  timeout = 10000;
  message = "";

  /**
   * Show error from backend
   * @param error
   */
  showError(error) {
    if (error) {
      let errorMessage = this.extractErrorFromBackend(error);
      this.showErrorMsg(errorMessage);
    } else {
      this.showErrorMsg(defaultErrorMessage);
    }
  }

  /**
   * Show string error msg
   * @param error
   */
  showErrorMsg(error) {
    this.timeout = 5000;
    if (error) {
      this.message = error;
    } else {
      this.message = defaultErrorMessage;
    }
    this.color = "#EF5B2D";
    this.show = true;
  }

  /**
   * Show string success msg
   * @param message
   */
  showSuccessMsg(message) {
    this.timeout = 5000;
    this.message = message;
    this.color = "#e9faff";
    this.show = true;
  }

  /**
   * Get color for text
   */
  get colorClass() {
    return `${this.color}--text font-weight-medium`;
  }

  /**
   * Extract error from backend
   * @param error
   * @returns {string}
   */
  extractErrorFromBackend(error) {
    let result = defaultErrorMessage;
    if (!error || !error.response || !error.response.data) return result;
    if (error.response.data.message) {
      result = error.response.data.message;
    }
    if (error.response.data.errors) {
      let errors = error.response.data.errors;
      var i = 0;
      let errorMessage = "";
      for (i = 0; i < errors.length; i++) {
        let err = errors[i];
        let message = err.field + ": " + err.defaultMessage;
        errorMessage = errorMessage + message + "\n";
      }
      if (errorMessage.length > 0) {
        result = errorMessage;
      }
    }
    return result;
  }
}
</script>

<style scoped></style>
